import { toQuery } from '@/utils/infrastructure';
import request from '@/utils/infrastructure/communication/request';

export async function queryCustomListActivate(params) {
  return request.post(`/customList/activate/${params}`, {});
}

export async function queryListPermissions(payload) {
  return request(`/${payload.route}`, {
    params: toQuery(payload.params),
  });
}

export async function querySavePermission(payload) {
  return request.post(`/customList/updatePermissions/${payload.id}`, {
    data: payload.data,
  });
}
export async function queryCustomListConfigure({ id }) {
  return request(`/customList/${id}`, {
    params: toQuery({
      select: 'name',
    }),
  });
}
